module.exports = __webpack_public_path__ + "img/Frame-54.4ada25ad.svg";